import "../../Styles/General & MultiUse/Rules.css";
import { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import ZGA from "../../Assets/ZGA.png";
import { RiCloseLargeLine } from "react-icons/ri";
import { ZGAContext } from "../../ZGAContext";

const Rules = () => {
  const { currentModal, closeModal, openModal } = useContext(ZGAContext);
  const [agreed, setAgreed] = useState(false);

  const handleAgreement = () => {
    setAgreed(!agreed);
  };

  useEffect(() => {
    if (currentModal === "rules") {
      setAgreed(false);
    }
    const handlePopState = () => {
      if (currentModal === "rules") {
        closeModal();
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [currentModal, closeModal]);

  if (currentModal !== "rules") return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop" onClick={closeModal}></div>
      <div className="rules">
        <div>
          <img src={ZGA} alt="The Zulaykha Global Academy" />
          <RiCloseLargeLine onClick={closeModal} />
        </div>
        <h1>Rules and regulations of the madrasah</h1>
        <ul>
          <li>
            Compulsory registration fee of &#8358;3,000 /$4/€3 should be made to the account of the madrasah before given
            test, after which the students will be added to her appropriate class.
          </li>
          <li>
            Evidence of payment should be sent to the accountant on WhatsApp via 08133128088 after which a form will be
            sent to the student to fill.
          </li>
          <li>Payment of madrasah fee starts from the beginning of every month till the 29thday of the month.</li>
          <li>
            Anyone who will not be able to meet up with the payment deadline should talk to theaccountant before the due
            date as delayed payment attracts #2,000 fine.
          </li>
          <li>Anyone who refuses to pay without pre-informing the accountant will be removed from theclass group.</li>
          <li>
            It is mandatory for you to always be regular with your classes and if you won’t be available for any class
            please inform your teacher earlier with tangible reasons, if you are not regular with your class and the
            defect is not from the teacher,note that you are making full payment for the month.
          </li>
          <li>
            You can always discuss with your teacher and if there is anything you don’t like or you want your teacher to
            improve on that would make you learn better,please talk to her about it.
          </li>
          <li>
            If you are having any issue concerning your class or your teacher,please don’t hesitate to inform the
            management.
          </li>
          <li>Please participate actively and follow the rules and regulations of the class.</li>
          <li>
            Payments should be made into any of the accounts below depending on your location and country of residence.
          </li>
          <li>May Allah bless the knowledge and reward your efforts with good in both worlds.</li>
        </ul>
        <div>
          <ul>
            <li style={{ listStyleType: agreed ? "disc" : "circle", cursor: "pointer" }} onClick={handleAgreement}>
              I agree to the terms and conditions
            </li>
          </ul>
          <button className={`${!agreed ? "active" : ""}`} disabled={!agreed} onClick={() => openModal("fees")}>
            Continue
          </button>
        </div>
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default Rules;
